/**
 * This file contains all of the actions used for the package complete tutorial.
 *
 * The package complete tutorial is the pop up that appears after a student
 * completes a package to congratulate them and remind them there are other
 * packages they can do.
 */

export const TRIGGER_PACKAGE_COMPLETE_TUTORIAL = 'TRIGGER_PACKAGE_COMPLETE_TUTORIAL';
export const DISMISS_PACKAGE_COMPLETE_TUTORIAL = 'DISMISS_PACKAGE_COMPLETE_TUTORIAL';
export const PACKAGE_STATES_WILL_UPDATE = 'PACKAGE_STATES_WILL_UPDATE';

/**
 * Action that is fired when the package complete tutorial should appear.
 */
export function triggerPackageCompleteTutorial(completedPackageDueDate, nextIncompletePackageID) {
    return {
        type: TRIGGER_PACKAGE_COMPLETE_TUTORIAL,
        completedPackageDueDate,
        nextIncompletePackageID,
    };
}

/**
 * Action that is fired when the package complete tutorial has been dismissed.
 */
export function dismissPackageCompleteTutorial() {
    return { type: DISMISS_PACKAGE_COMPLETE_TUTORIAL };
}

/**
 * Action that is fired when a package state is about to update.
 * This is used to detect when a package has been completed. We cannot use
 * UPDATE_PACKAGE_STATES for this purpose as the store would already have been
 * updated with the new state by the time the saga would run.
 */
export function packageStatesWillUpdate(newPackageStates) {
    return { type: PACKAGE_STATES_WILL_UPDATE, newPackageStates };
}
